<template>
    <div>
        <div class="common-header-wrap">
            <mt-header title="Shop map" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="common-no-more" v-if="store && !(store.store_latitude && store.store_longitude)">
          The shop has not set an address
        </div>
        <iframe class="map-content" v-if="getUrl || iframeUrl" :src="iframeUrl"></iframe>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import { getPosition,convertPoint } from '../../../util/bmap'
import { getStoreInfo,getStoreMap } from '../../../api/homestoredetail'

export default {
  data () {
    return {
      iframeUrl:'',
      store: false,
      store_id: this.$route.query.id ? this.$route.query.id : '',
      o_lat: false,
      o_lng: false,
      d_lat: false,
      d_lng: false,
    }
  },
  created () {
    getStoreInfo(
      this.store_id
    ).then((res) => {
      this.store = res.result.store_info
      if(this.store.store_longitude && this.store.store_latitude){
      convertPoint(this.store.store_longitude,this.store.store_latitude).then(result=>{
        if(result.status==0){
          this.d_lat = result.result[0].y
          this.d_lng = result.result[0].x
        }else{
          Toast('Coordinate conversion failed')
        }
      }).catch(error => {
        console.log(error)
        Toast('Failed to call coordinate conversion interface')
      })
      }
    }).catch(error => {
      Toast(error.message)
    })
    var _this = this
    getPosition(function (res) {
      if (res.code === 10000) {
        _this.o_lat = res.result.lat
        _this.o_lng = res.result.lng
      } else {
        Toast(res.message)
      }
    }, true)
  },
  computed: {
    getUrl: function () {
      if (this.d_lat && this.d_lng && this.o_lat && this.o_lng) {
        getStoreMap({region:this.store.area_info,o_lng:this.o_lng,o_lat:this.o_lat,o_name:'我',d_lng:this.d_lng,d_lat:this.d_lat,d_name:this.store.store_name}).then(res=>{
          
          this.iframeUrl = res.result.url
          console.log(this.iframeUrl)
        }).catch(error=>{
          Toast(error.message)
        })
      }
    }
  },
  methods: {

  }

}
</script>

<style scoped>
.map-content{position: absolute;padding-top:2rem;width:100%;height:100%;top:0;box-sizing: border-box;border: 0}
</style>
